import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "material-icons" }
const _hoisted_2 = { class: "material-icons" }
const _hoisted_3 = ["id", "placeholder", "type", "aria-label", "disabled", "required", "readonly"]
const _hoisted_4 = ["id", "placeholder", "type", "required", "readonly"]
const _hoisted_5 = ["for"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "maz-input__toggle-btn__icon material-icons" }, " close ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "maz-input__toggle-btn__icon material-icons" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "maz-input__loader__progress-bar" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "parent",
    class: _normalizeClass([[{
      'is-focused': _ctx.isFocus || _ctx.focus,
      'is-valid': _ctx.success,
      'has-value': _ctx.modelValue,
      'is-textarea': _ctx.textarea,
      'has-error': _ctx.error,
      'has-warning': _ctx.warning,
      'is-disabled': _ctx.disabled,
      'maz-is-dark': _ctx.dark,
      'has-hint': _ctx.hint,
      'has-no-label': !_ctx.hasLabel && !_ctx.hint,
      'has-left-icon': _ctx.hasLeftIcon(),
    }, `maz-input--${_ctx.size}`, `has-${_ctx.leftNumberIcon}-right-icon`, `maz-input--${_ctx.color}`], "maz-base-component maz-input maz-border maz-border-color maz-border-color-hover maz-border-solid maz-border-radius"]),
    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)))
  }, [
    (_ctx.hasLeftIcon())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["maz-input__icon maz-flex left", [_ctx.textarea ? 'maz-align-start maz-pt-2' : 'maz-align-center']])
        }, [
          _renderSlot(_ctx.$slots, `icon-left`, {}, () => [
            _createElementVNode("i", _hoisted_1, _toDisplayString(_ctx.leftIconName), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.hasRightIcon())
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["maz-input__icon maz-flex right", [_ctx.textarea ? 'maz-align-start maz-pt-2' : 'maz-align-center']])
        }, [
          _renderSlot(_ctx.$slots, `icon-right`, {}, () => [
            _createElementVNode("i", _hoisted_2, _toDisplayString(_ctx.rightIconName), 1)
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.textarea)
      ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
          key: 2,
          id: _ctx.uniqueId,
          ref: "MazInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
        }, _ctx.$attrs, {
          placeholder: _ctx.placeholderValue,
          type: _ctx.getType,
          class: ["maz-input__input maz-border-radius", {
        'has-right-icon': _ctx.hasClearBtn || _ctx.hasPasswordBtn || _ctx.hasRightIcon()
      }],
          "aria-label": _ctx.placeholder,
          disabled: _ctx.disabled,
          required: _ctx.required,
          readonly: _ctx.readonly,
          onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.keyDown && _ctx.keyDown(...args))),
          onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.keyUp && _ctx.keyUp(...args))),
          onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onPaste: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('click', $event)))
        }), null, 16, _hoisted_3)), [
          [_vModelDynamic, _ctx.inputValue]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("textarea", _mergeProps({
          key: 3,
          id: _ctx.uniqueId,
          ref: "MazInput",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValue) = $event))
        }, _ctx.$attrs, {
          placeholder: _ctx.placeholderValue,
          type: _ctx.type,
          required: _ctx.required,
          readonly: _ctx.readonly,
          class: "maz-input__input maz-textarea",
          onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.keyDown && _ctx.keyDown(...args))),
          onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.keyUp && _ctx.keyUp(...args))),
          onFocus: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onPaste: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onPaste && _ctx.onPaste(...args))),
          onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('click', $event)))
        }), null, 16, _hoisted_4)), [
          [_vModelText, _ctx.inputValue]
        ]),
    (_ctx.hasLabel || _ctx.hint)
      ? (_openBlock(), _createElementBlock("label", {
          key: 4,
          ref: "label",
          for: _ctx.uniqueId,
          class: _normalizeClass([_ctx.error ? 'maz-text-danger' : null, "maz-input__label"]),
          tabindex: "-1",
          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.focusInput && _ctx.focusInput(...args)))
        }, _toDisplayString(_ctx.hintValue || _ctx.placeholderValue), 11, _hoisted_5))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "maz-scale" }, {
      default: _withCtx(() => [
        (_ctx.hasClearBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: "clear-button",
              class: _normalizeClass(["maz-input__toggle-btn --clear maz-flex maz-flex-center", { 'has-right-icon': _ctx.hasRightIcon() }]),
              title: "clear",
              type: "button",
              tabindex: "-1",
              onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)), ["stop"]))
            }, _hoisted_7, 2))
          : _createCommentVNode("", true),
        (_ctx.hasPasswordBtn)
          ? (_openBlock(), _createElementBlock("button", {
              key: "password-button",
              class: _normalizeClass(["maz-input__toggle-btn password maz-flex maz-flex-center", {
          'has-clear-btn': _ctx.hasClearBtn,
          'has-right-icon': _ctx.hasRightIcon()
        }]),
              title: "clear",
              type: "button",
              tabindex: "-1",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
            }, [
              _createElementVNode("i", _hoisted_8, _toDisplayString(_ctx.showPassword ? 'visibility_off' : 'visibility'), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 5,
          class: _normalizeClass(["maz-input__loader", { textarea: _ctx.textarea }])
        }, _hoisted_10, 2))
      : _createCommentVNode("", true)
  ], 2))
}